import request from '@/assets/scripts/utils/request';
// 收藏
export function addCollect(data) {
    return request({
        url: '/science/addCollect',
        method: 'post',
        data
    });
}
// 取消收藏
export function cancelCollect(data) {
    return request({
        url: '/science/cancelCollect',
        method: 'post',
        data
    });
}

// 点赞
export function addSupport(data) {
    return request({
        url: '/science/addSupport',
        method: 'post',
        data
    });
}
// 取消点赞
export function cancelSupport(data) {
    return request({
        url: '/science/cancelSupport',
        method: 'post',
        data
    });
}

// 获取省市区
export function getDistrictTree(data) {
    return request({
        url: '/science/getDistrictTree',
        method: 'post',
        data
    });
}

// 获取微信token
export function getWxToken({strURL,wxNum=1}) {
    return request({
        url: '/wx/getWxToken?url='+strURL+'&wxNum='+wxNum,
        method: 'get'
    });
}